import { translate } from '../../../../utils/translation'
import { Text } from '../../../topography'
import ashleeWhitePhoto from '../../../../styles/assets/checkoutModal/ashlee-white.svg'

export default () => {
  return (
    <>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <img src={ashleeWhitePhoto} alt="Ashlee White" />
        <Text
          fontSize="12px"
          lineHeight="18px"
          margin="0 0 0 10px"
          fontWeight="bold"
        >
          {translate('ashlee_white')}
        </Text>
      </div>
      <Text fontSize="14px" lineHeight="19.6px" margin="16px 0 0 0">
        {translate('ashlee_review')}
      </Text>
    </>
  )
}
